// src/components/Career/PublicApplyForm.js

import React, { useState } from "react";
import { postData } from "../../services/FetchNodeservices";

export default function PublicApplyForm({ job }) {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({
    f_name: "",
    l_name: "",
    email_id: "",
    phone_number: "",
    qualification: "",
    experience: "",
    current_company: "",
    designation: "",
    current_ctc: "",
    expected_ctc: "",
    notice_period: "",
    reason_for_change: "",
    hometown: "",
    application_date: new Date().toISOString().split("T")[0],
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setForm({
        ...form,
        [name]: files[0],
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setUploading(true);
    setMessage("");

    try {
      const formData = new FormData();

      Object.entries(form).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append("req_id", job.reqId);

      const result = await postData(
        "career/apply",
        formData,
        true
      );

      if (result.status) {
        setMessage(
          "✅ Application submitted successfully. Our recruitment team will contact you if your profile matches the requirement."
        );

        setForm({
          f_name: "",
          l_name: "",
          email_id: "",
          phone_number: "",
          qualification: "",
          experience: "",
          current_company: "",
          designation: "",
          current_ctc: "",
          expected_ctc: "",
          notice_period: "",
          reason_for_change: "",
          hometown: "",
          application_date:
            new Date().toISOString().split("T")[0],
          resume: null,
        });

        const fileInput =
          document.getElementById("resumeUpload");

        if (fileInput) {
          fileInput.value = "";
        }
      } else {
        setMessage(
          result.message ||
            "Unable to submit application."
        );
      }
    } catch (error) {
      console.error(error);

      setMessage(
        "Something went wrong. Please try again later."
      );
    }

    setUploading(false);
  };

  return (
    <div
      id="applyForm"
      className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 mt-10"
    >
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-gray-900">
          Apply for this Position
        </h2>

        <p className="text-gray-500 mt-2">
          Complete the application below and upload your latest resume.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="grid md:grid-cols-2 gap-5">
          <input
            type="text"
            name="f_name"
            placeholder="First Name"
            value={form.f_name}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="l_name"
            placeholder="Last Name"
            value={form.l_name}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="email"
            name="email_id"
            placeholder="Email Address"
            value={form.email_id}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="tel"
            name="phone_number"
            placeholder="Mobile Number"
            value={form.phone_number}
            onChange={handleChange}
            required
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="qualification"
            placeholder="Highest Qualification (MBA, B.Tech, MCA, etc.)"
            value={form.qualification}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="experience"
            placeholder="Total Experience (e.g. 5 Years)"
            value={form.experience}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="current_company"
            placeholder="Current Company Name"
            value={form.current_company}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="designation"
            placeholder="Current Designation"
            value={form.designation}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="current_ctc"
            placeholder="Current CTC (e.g. ₹8 LPA)"
            value={form.current_ctc}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="expected_ctc"
            placeholder="Expected CTC (e.g. ₹12 LPA)"
            value={form.expected_ctc}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="notice_period"
            placeholder="Notice Period (Immediate / 15 Days / 30 Days)"
            value={form.notice_period}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />

          <input
            type="text"
            name="hometown"
            placeholder="Current Location (Mumbai, Pune, Delhi, etc.)"
            value={form.hometown}
            onChange={handleChange}
            className="border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          />
        </div>

        <div className="mt-6">
          <textarea
            name="reason_for_change"
            placeholder="Why are you looking for a new opportunity?"
            value={form.reason_for_change}
            onChange={handleChange}
            rows={5}
            className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none transition"
          />
        </div>

        <div className="mt-6 border-2 border-dashed border-gray-300 rounded-2xl p-6 text-center">
          <div className="text-5xl mb-3">📄</div>

          <h3 className="font-semibold text-lg">
            Upload Resume
          </h3>

          <p className="text-gray-500 text-sm mt-2">
            Accepted formats: PDF, DOC, DOCX
          </p>

          <input
            id="resumeUpload"
            type="file"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
            required
            className="mt-4"
          />
        </div>

        {message && (
          <div
            className={`mt-6 p-4 rounded-xl ${
              message.includes("✅")
                ? "bg-green-100 text-green-700 border border-green-200"
                : "bg-red-100 text-red-700 border border-red-200"
            }`}
          >
            {message}
          </div>
        )}

        <button
          type="submit"
          disabled={uploading}
          className="w-full mt-8 py-4 rounded-xl bg-slate-900 text-white text-lg font-semibold hover:bg-black transition-all duration-300"
        >
          {uploading
            ? "Submitting Application..."
            : "Apply Now"}
        </button>
      </form>
    </div>
  );
}